<template>
  <header class="">
    <nav class="fixed top-0 z-10 w-full bg-white backdrop-blur-lg border-gray-200 border-b">
      <div class="flex h-[70px] mx-auto max-w-4xl justify-between items-center">
        <a
          class="flex items-center"
          href="/"
        >
          <img
            alt="Nevcap Logo"
            class="mr-3 h-8 sm:h-8"
            src="../../../assets/images/nevcap-logo.svg"
          >
        </a>
        <div class="flex items-center gap-6 lg:order-2">
          <router-link
            id="hs-mega-menu-basic-dr"
            class="text-sm font-medium text-gray-600 hover:text-gray-900 whitespace-nowrap"
            to="/dashboard"
          >
            Home
          </router-link>
          <router-link
            v-if="isCommunityPlus"
            id="hs-mega-menu-basic-dr"
            class="text-sm font-medium text-gray-600 hover:text-gray-900 whitespace-nowrap"
            to="/academy"
          >
            Academy
          </router-link>
          <router-link
            v-if="user?.role === 'admin'"
            id="hs-mega-menu-basic-dr"
            class="text-sm font-medium text-gray-600 hover:text-gray-900 whitespace-nowrap"
            to="/dashboard/directory"
          >
            Directory
          </router-link>
          <router-link
            id="hs-mega-menu-basic-dr"
            class="text-sm font-medium text-gray-600 hover:text-gray-900 whitespace-nowrap"
            to="/dashboard/events"
          >
            Events
          </router-link>
          <router-link
            id="hs-mega-menu-basic-dr"
            class="text-sm font-medium text-gray-600 hover:text-gray-900 whitespace-nowrap"
            to="/dashboard/account"
            type="button"
          >
            My Account
          </router-link>
          <div class="relative inline-block">
            <DropdownMenu>
              <template #trigger>
                <button
                  aria-expanded="false"
                  class="flex items-center justify-center text-sm w-10 h-10 bg-[#262223] border border-[#d7c0ae] rounded-full md:me-0 focus:ring-4 focus:ring-[#d7c0ae]"
                  type="button"
                >
                  <span class="sr-only">Open user menu</span>
                  <span class="fill-white">
                    <img
                      alt=""
                      class="h-5 w-5"
                      src="../../../assets/images/person.svg"
                    >
                  </span>
                </button>
              </template>
              <template #content>
                <div class="px-4 py-4 border-b border-gray-100">
                  <div class="flex items-center gap-3">
                    <div class="h-9 w-9 rounded-full bg-[#f6f1ec] flex items-center justify-center text-xs font-semibold text-gray-700">
                      {{ user?.fullName?.[0] || 'N' }}
                    </div>
                    <div>
                      <span class="block text-sm font-semibold text-gray-900">{{ user?.fullName }}</span>
                      <span class="block text-xs text-gray-500 truncate">{{
                        user ? user.email : ''
                      }}</span>
                    </div>
                  </div>
                </div>
                <ul class="py-2">
                  <li v-if="user?.role === 'admin'">
                    <router-link
                      class="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      to="/administrator"
                    >
                      <ShieldCheckIcon class="h-4 w-4 text-gray-500" />
                      Admin Panel
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      class="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      to="/dashboard"
                    >
                      <HomeIcon class="h-4 w-4 text-gray-500" />
                      Dashboard
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      class="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      to="/dashboard/settings"
                    >
                      <Cog6ToothIcon class="h-4 w-4 text-gray-500" />
                      Settings
                    </router-link>
                  </li>
                  <li class="border-t border-gray-100 mt-2 pt-2">
                    <a
                      class="flex items-center gap-2 px-4 py-2 text-sm cursor-pointer text-gray-700 hover:bg-gray-100"
                      @click="logout"
                    >
                      <ArrowRightOnRectangleIcon class="h-4 w-4 text-gray-500" />
                      Sign out
                    </a>
                  </li>
                </ul>
              </template>
            </DropdownMenu>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>
<script lang="ts">
import {computed, defineComponent, inject} from 'vue';
import {useRouter} from 'vue-router';
import axios, {AxiosError} from 'axios';
import Dropdown from '@/components/Dropdown.vue';
import {userKey} from '@/composables/useUser';
import {ErrorResponse} from "@/types";
import {
  ArrowRightOnRectangleIcon,
  Cog6ToothIcon,
  HomeIcon,
  ShieldCheckIcon,
} from "@heroicons/vue/24/outline";

export default defineComponent({
  name: 'Navbar',
  components: {
    DropdownMenu: Dropdown,
    ArrowRightOnRectangleIcon,
    Cog6ToothIcon,
    HomeIcon,
    ShieldCheckIcon,
  },
  setup() {
    const {user} = inject(userKey)!;
    const router = useRouter();

    const logout = async () => {
      try {
        await axios.post("/auth/logout");
        user.value = undefined;
        await router.push("/login");
      } catch (error: unknown) {
        const axiosError = error as AxiosError<ErrorResponse>;
        const message = axiosError.response?.data?.message || axiosError.message;
        console.error('Logout error:', message);
      }
    };

    const isCommunityPlus = computed(() => user.value?.membershipPlan === 'community_plus');

    return {user, router, logout, isCommunityPlus};
  },
});
</script>
